module.exports = __webpack_public_path__ + "img/pr-1.17ea1b34.png";